// extracted by mini-css-extract-plugin
export default {"container":"settings_container__qSsHh","tabs":"tabs","ant-tabs-nav":"ant-tabs-nav","antTabsNav":"ant-tabs-nav"};